import React, { useState } from 'react';

export default function usePopper({
  showPopper = true
}: {
  showPopper?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement>(null);
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!showPopper) {
      return;
    }
    setIsPopperOpen(true);
    setAnchorEl(e.currentTarget);
  };
  const handleMouseLeave = () => {
    if (!showPopper) {
      return;
    }
    setIsPopperOpen(false);
    setAnchorEl(null);
  };
  return {
    handleMouseEnter,
    handleMouseLeave,
    anchorEl,
    isPopperOpen
  };
}
